import { range } from "../../modules/api";

const state = {
  ranges: [],
  currentRangeId: null,
  aliases: [],
  elements: [
    { id: 1, active: true, key: "sugar", label: "Total Sugars" },
    { id: 2, active: true, key: "pH", label: "pH" },
    { id: 3, active: true, key: "EC", label: "EC" },
    { id: 4, active: true, key: "potassium", label: "Potassium" },
    { id: 5, active: true, key: "calcium", label: "Calcium" },
    { id: 6, active: true, key: "magnesium", label: "Magnesium" },
    { id: 7, active: true, key: "sodium", label: "Sodium" },
    { id: 8, active: true, key: "ammonium", label: "Ammonium" },
    { id: 9, active: true, key: "NO3_nitrate", label: "Nitrate" },
    { id: 10, active: true, key: "nitrogen_in_nitrate", label: "N in Nitrate" },
    { id: 11, active: true, key: "nitrogen", label: "Total Nitrogen" },
    { id: 12, active: true, key: "chloride", label: "Chloride" },
    { id: 13, active: true, key: "sulfur", label: "Sulfur" },
    { id: 14, active: true, key: "phosphorous", label: "Phosphorus" },
    { id: 15, active: true, key: "silica", label: "Silica" },
    { id: 16, active: true, key: "iron", label: "Iron" },
    { id: 17, active: true, key: "manganese", label: "Manganese" },
    { id: 18, active: true, key: "zinc", label: "Zinc" },
    { id: 19, active: true, key: "boron", label: "Boron" },
    { id: 20, active: true, key: "copper", label: "Copper" },
    { id: 21, active: true, key: "molybdenum", label: "Molybdenum" },
    { id: 23, active: true, key: "cobalt", label: "Cobalt" },
    { id: 22, active: true, key: "aluminium", label: "Aluminium" },
  ],
};

const getters = {
  currentRangeTitle(state) {
    let currentRange;
    if (state.currentRangeId) {
      currentRange = state.ranges.find(x => x.indicatorSetId === state.currentRangeId);
    }

    if (!currentRange) {
      currentRange = state.ranges.find(x => x.isDefault);
    }

    if (!currentRange) {
      currentRange = state.ranges[0];
    }

    return currentRange?.setName || "";
  },
  getRanges: state => {
    let cloned = [...state.ranges];

    if (!cloned || !cloned[0]) {
      return [];
    }

    let currentRange;
    if (state.currentRangeId) {
      currentRange = cloned.find(x => x.indicatorSetId === state.currentRangeId);
    }

    if (!currentRange) {
      currentRange = cloned.find(x => x.isDefault);
    }

    if (!currentRange) {
      currentRange = cloned[0];
    }

    let ranges = currentRange.ranges;

    for (let alias of state.aliases) {
      let range = currentRange.ranges.find(x => x.cropName === alias.cropName);
      if (range) {
        let aliasRange = { ...range };
        aliasRange.cropName = alias.aliasName;
        ranges.push(aliasRange);
      }
    }

    return ranges;
  },
  getRangeBooks(state) {
    let books = Array.from(new Set(state.ranges.map(x => ({ name: x.setName, id: x.indicatorSetId, description: x.description }))));
    return books;
  },
  getAliases(state) {
    return state.aliases;
  },
  elements(state) {
    return state.elements;
  },
};

const mutations = {
  setRanges: (state, payload) => {
    state.ranges = payload;
  },
  setAliases(state, payload) {
    if (payload) {
      state.aliases = [...payload, ...state.aliases];
    }
  },
  setCurrentRangeId(state, id) {
    state.currentRangeId = id;
  },
};

const actions = {
  async fetchAllRanges({ commit }) {
    let ranges = await range.get("all", "all");

    commit("setRanges", ranges.ranges);
    commit("setAliases", ranges.aliases);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
